import MaskToggle from './MaskToggle';
import { LoggerIcon } from './LoggerIcon';
import { useState } from 'react';
import { X, Navigation, RefreshCw, Inbox, SearchCheck } from 'lucide-react';
import DictateField from './DictateField';
import { routeLink } from '../lib/route';
import { H, loggerState, LOG_COLORS, fmtDuration } from '../hooks/useLoggers';

const DUR = [1, 2, 3, 7];
const toLocal = (ms) => new Date(ms - new Date(ms).getTimezoneOffset() * 60000).toISOString().slice(0, 16);

export function LoggerDialog({ t, lg }) {
  const [name, setName] = useState('');
  const [mode, setMode] = useState('lift');
  const [days, setDays] = useState(1);
  const [custom, setCustom] = useState(toLocal(Date.now() + 24 * H));
  if (!lg.dlg) return null;
  const durMs = days === 'custom' ? Math.max(H / 4, new Date(custom).getTime() - Date.now()) : days * 24 * H;
  return (
    <div className="editor-backdrop lg-backdrop" data-testid="logger-dialog">
      <div className="lg-modal mask">
        <div className="lg-head mask-keep"><LoggerIcon size={18} /><b>{t.lgNew}</b><MaskToggle t={t} id="logger-dialog" /><button className="icon-btn" data-testid="logger-dialog-close" onClick={() => lg.setDlg(null)}><X size={16} /></button></div>
        <label className="lg-label">{t.lgName}</label>
        <DictateField t={t} value={name} onChange={setName} testid="logger-name-input" placeholder={t.lgNamePh} />
        <div className="lg-modes">
          {['lift', 'perm'].map((m) => (
            <button key={m} className={`lg-mode ${mode === m ? 'on' : ''}`} data-testid={`logger-mode-${m}`} onClick={() => setMode(m)}>{t['lgMode_' + m]}</button>
          ))}
        </div>
        {mode === 'lift' && (
          <>
            <label className="lg-label">{t.lgCollectAfter}</label>
            <div className="lg-durs">
              {DUR.map((d) => <button key={d} className={`chip seg ${days === d ? 'on' : ''}`} data-testid={`logger-dur-${d}`} onClick={() => setDays(d)}>{t['lgDur_' + d]}</button>)}
              <button className={`chip seg ${days === 'custom' ? 'on' : ''}`} data-testid="logger-dur-custom" onClick={() => setDays('custom')}>{t.lgDurCustom}</button>
            </div>
            {days === 'custom' && <input type="datetime-local" className="lg-date" data-testid="logger-due-input" value={custom} onChange={(e) => setCustom(e.target.value)} />}
          </>
        )}
        <button className="btn btn-accent" data-testid="logger-save-btn" onClick={() => lg.save({ name: name.trim(), mode, durMs })}>{t.lgSave}</button>
      </div>
    </div>
  );
}

const fmtL = (ms, loc) => new Date(ms).toLocaleString(loc, { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

export function LoggerSheet({ t, lg }) {
  const fmt = (ms) => fmtL(ms, t.locale);
  const l = lg.list.find((x) => x.id === lg.selId);
  if (!l) return null;
  const st = loggerState(l);
  return (
    <div className="lg-sheet mask" data-testid="logger-sheet">
      <div className="lg-sheet-head mask-keep">
        <i style={{ background: LOG_COLORS[st] }} />
        <span><b data-testid="logger-sheet-name">{l.name}</b><small data-testid="logger-sheet-status">{t['lgMode_' + l.mode]} · {t['lgSt_' + st]}</small></span>
        <MaskToggle t={t} id="logger-sheet" />
        <button className="icon-btn" data-testid="logger-sheet-close" onClick={() => lg.setSelId(null)}><X size={15} /></button>
      </div>
      <p className="lg-times">{t.lgPlacedAt} {fmt(l.placedAt)} ({fmtDuration(Date.now() - l.placedAt, t)}){l.dueAt ? ` · ${t.lgDue} ${fmt(l.dueAt)}` : ''}</p>
      {l.missingAt && <p className="lc-missing-n" data-testid="logger-sheet-missing">⚠ {t.lgSt_missing} {fmt(l.missingAt)}{l.finding?.note ? ` – ${l.finding.note}` : ''}</p>}
      <div className="lg-actions">
        <a className="btn btn-primary btn-sm" data-testid="logger-nav-btn" href={routeLink(l)} target="_blank" rel="noreferrer"><Navigation size={14} /> {t.alNav}</a>
        <button className="btn btn-outline btn-sm" data-testid="logger-move-btn" onClick={() => lg.startMove(l.id)}><RefreshCw size={14} /> {t.lgMove}</button>
        {l.missingAt && <button className="btn btn-accent btn-sm" data-testid="logger-found-btn" onClick={() => lg.found(l.id)}><SearchCheck size={14} /> {t.lcFound}</button>}
        <button className="btn btn-green btn-sm" data-testid="logger-collect-btn" onClick={() => lg.collect(l.id)}><Inbox size={14} /> {t.lcOpen}</button>
      </div>
    </div>
  );
}
